import { SIDE_BAR_ITEMS } from '../../constants/strings'
import {
  BOOKABLE_ACTIVITIES,
  HOME,
  SUPPLIER,
  USERS,
  TRIPS,
  BOOKINGS,
  PAYMENTS,
  SPREADSHEET_IMPORT,
  OUTREACH,
  ANALYTICS,
  TRIP_INSPIRATION,
  NUDGES,
} from '../../routesConstants'
import React from 'react'
import { ReactComponent as Home } from '../../assets/icons/side-bar/home.svg'
import { ReactComponent as Scorecards } from '../../assets/icons/side-bar/scorecards.svg'
import LogoutIcon from '@mui/icons-material/Logout'
import { COLORS } from '../../constants/colors'
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import BarChartIcon from '@mui/icons-material/BarChart'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive'
import { Roles } from '../../constants/enums'

export const TOP_SIDE_BAR_ITEMS = [
  {
    id: 1,
    title: SIDE_BAR_ITEMS.HOME,
    path: HOME,
    icon: <Home />,
  },
  {
    id: 2,
    title: SIDE_BAR_ITEMS.BA,
    path: BOOKABLE_ACTIVITIES,
    icon: <Scorecards />,
    allowedRoles: [Roles.ADMIN, Roles.SUPERADMIN, Roles.SUPPLIER],
  },
  {
    id: 3,
    title: SIDE_BAR_ITEMS.SUPPLIER,
    path: SUPPLIER,
    icon: <FormatAlignCenterIcon style={{ color: COLORS.lightGray }} fontSize="small" />,
    allowedRoles: [Roles.ADMIN, Roles.SUPERADMIN],
  },
  {
    id: 4,
    title: SIDE_BAR_ITEMS.USERS,
    path: USERS,
    icon: <FormatAlignCenterIcon style={{ color: COLORS.lightGray }} fontSize="small" />,
    allowedRoles: [Roles.ADMIN, Roles.SUPERADMIN],
  },
  {
    id: 5,
    title: SIDE_BAR_ITEMS.TRIPS,
    path: TRIPS,
    icon: <FormatAlignCenterIcon style={{ color: COLORS.lightGray }} fontSize="small" />,
    allowedRoles: [Roles.ADMIN, Roles.SUPERADMIN],
  },
  {
    id: 8,
    title: 'Import Trip',
    path: SPREADSHEET_IMPORT,
    icon: <CloudUploadIcon style={{ color: COLORS.lightGray }} fontSize="small" />,
    allowedRoles: [Roles.ADMIN, Roles.SUPERADMIN],
  },
  {
    id: 6,
    title: SIDE_BAR_ITEMS.BOOKINGS,
    path: BOOKINGS,
    icon: <FormatAlignCenterIcon style={{ color: COLORS.lightGray }} fontSize="small" />,
    allowedRoles: [Roles.ADMIN, Roles.SUPERADMIN, Roles.SUPPLIER],
  },
  {
    id: 7,
    title: SIDE_BAR_ITEMS.PAYMENTS,
    path: PAYMENTS,
    icon: <FormatAlignCenterIcon style={{ color: COLORS.lightGray }} fontSize="small" />,
    allowedRoles: [Roles.ADMIN, Roles.SUPERADMIN, Roles.SUPPLIER],
  },
  {
    id: 9,
    title: SIDE_BAR_ITEMS.OUTREACH,
    path: OUTREACH,
    icon: <FormatAlignCenterIcon style={{ color: COLORS.lightGray }} fontSize="small" />,
    allowedRoles: [Roles.ADMIN, Roles.SUPERADMIN],
  },
  {
    id: 10,
    title: SIDE_BAR_ITEMS.ANALYTICS,
    path: ANALYTICS,
    icon: <BarChartIcon style={{ color: COLORS.lightGray }} fontSize="small" />,
    allowedRoles: [Roles.ADMIN, Roles.SUPERADMIN],
  },
  {
    id: 12,
    title: 'Trip Inspiration',
    path: TRIP_INSPIRATION,
    icon: <AutoAwesomeIcon style={{ color: COLORS.lightGray }} fontSize="small" />,
    allowedRoles: [Roles.ADMIN, Roles.SUPERADMIN],
  },
  {
    id: 11,
    title: 'Nudges',
    path: NUDGES,
    icon: <NotificationsActiveIcon style={{ color: COLORS.lightGray }} fontSize="small" />,
    allowedRoles: [Roles.ADMIN, Roles.SUPERADMIN],
  },
  // {
  //   id: 4,
  //   path: 'test',
  //   title: SIDE_BAR_ITEMS.INFOS,
  //   icon: <Dashboards />,
  // },
  // {
  //   id: 5,
  //   path: 'test',
  //   title: SIDE_BAR_ITEMS.PAYMENTS,
  //   icon: <Integrations />,
  // },
]

export const BOTTOM_SIDE_BAR_ITEMS = (user) => {
  return [
    {
      id: 4,
      title: 'Logout',
      path: 'login',
      // icon: <img src={user.photo ? user.photo : profileImage} className={styles.profileImg} alt={'user'}/>,
      icon: <LogoutIcon style={{ color: COLORS.lightGray }} fontSize="small" />,
      isProfile: true,
    },
  ]
}
